import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import icon_attach_doc from "../../../../Image/icon_attach_doc.png";
import Swal from "sweetalert2";
import icon_import from "../../../../Image/icon_import.png";
import logo_del from "../../../../Image/logo_del.png";
import icon_pdf from "../../../../Image/icon_pdf.png";
import no_documents from "../../../../Image/no_documents.png";
import {
  GetLocalStorageAccessToken,
  webapi,
  APIEndpointWeb,
} from "../../../../client/web";

interface FileBase64 {
  name: string;
  base64: any;
}

interface IModalOpenPDF {
  setOpenAttachDoc: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  openAttachDoc: boolean;
  dataPageForm: any;
  fileslength: number;
  getFilesPDF: () => void;
}

const DialogAttachDocPDF: React.FC<IModalOpenPDF> = ({
  openAttachDoc,
  setLoading,
  setOpenAttachDoc,
  dataPageForm,
  getFilesPDF,
  fileslength,
}) => {
  const [nameDoc, setNameDoc] = useState("");
  const hiddenFileInputCreatePDF = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<FileBase64[]>([]);
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  // const [loading, setLoading] = useState<boolean>(false);

  const handleCloseSuccessDialog = () => {
    setOpenAttachDoc(false);
  };

  const handleNameDoc = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNameDoc(e.target.value);
  };

  const handleDrop = (event: any) => {
    event.preventDefault();
    // const droppedFiles = Array.from(event.dataTransfer.files);
    const files = event.dataTransfer.files;
    const target = { files } as unknown as HTMLInputElement;
    const changeEvent = { target } as React.ChangeEvent<HTMLInputElement>;
    uploadPDF(changeEvent);
    // console.log("droppedFiles", droppedFiles)
    // setFiles(droppedFiles);
  };

  const uploadPDF = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      let fileArray = Array.from(files);

      // Limit to 5 files
      // if (fileArray.length + selectedFiles.length > 1) {
      //     Swal.fire({
      //         title: "เลือกไฟล์มากเกินไป",
      //         text: "สามารถเลือกได้สูงสุด 1 ไฟล์เท่านั้น",
      //         icon: "warning",
      //     });
      //     return false;
      // }

      // Validate file type and size
      fileArray = fileArray.filter((file) => {
        if (file.type !== "application/pdf") {
          Swal.fire({
            title: "ไฟล์ไม่ถูกต้อง",
            text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
            icon: "error",

            confirmButtonText: "ตกลง",
          });
          return false;
        }

        if (file.size > 2 * 1024 * 1024) {
          Swal.fire({
            title: "ไฟล์ใหญ่เกินไป",
            text: `ไฟล์ "${file.name}" มีขนาดเกิน 2MB`,
            icon: "error",

            confirmButtonText: "ตกลง",
          });
          return false;
        }

        return true;
      });

      if (fileArray.length === 0) {
        return false;
      }
      // var jsonParseOFselectedFiles: File[] = []
      var jsonBase64: FileBase64[] = [];
      // selectedFiles.map(async (data) => {
      //     jsonBase64.push(data);
      // });

      for (var xml in fileArray) {
        try {
          let base64 = await convertFileToBase64(fileArray[xml]);
          let filebase64: FileBase64 = {
            name: fileArray[xml].name,
            base64: base64,
          };
          jsonBase64.push(filebase64);
        } catch (error) {
          console.log("error", error);
        }
      }

      setSelectedFiles(jsonBase64);
      // Convert files to base64
      // const base64Files = await Promise.all(fileArray.map(getBase64File));
      // console.log("Uploaded PDFs:", base64Files);
    } catch (error) {
      console.error("File upload error:", error);
    } finally {
      e.target.value = ""; // Reset input field
    }
  };

  // const uploadPDF = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //     try {

  //         const files = e.target.files;
  //         if (!files || files.length === 0) return;

  //         let fileArray = Array.from(files);

  //         // Limit to 5 files
  //         if (fileArray.length + selectedFiles.length > 1) {
  //             Swal.fire({
  //                 title: "เลือกไฟล์มากเกินไป",
  //                 text: "สามารถเลือกได้สูงสุด 1 ไฟล์เท่านั้น",
  //                 icon: "warning",
  //             });
  //             return false;
  //         }

  //         // Validate file type and size
  //         fileArray = fileArray.filter((file) => {
  //             if (file.type !== "application/pdf") {
  //                 Swal.fire({
  //                     title: "ไฟล์ไม่ถูกต้อง",
  //                     text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
  //                     icon: "error",
  //                 });
  //                 return false;
  //             }

  //             if (file.size > 2 * 1024 * 1024) {
  //                 Swal.fire({
  //                     title: "ไฟล์ใหญ่เกินไป",
  //                     text: `ไฟล์ "${file.name}" มีขนาดเกิน 2MB`,
  //                     icon: "error",
  //                 });
  //                 return false;
  //             }

  //             return true;
  //         });

  //         if (fileArray.length === 0) {
  //             return false;
  //         }
  //         // var jsonParseOFselectedFiles: File[] = []
  //         var jsonBase64: FileBase64[] = [];
  //         selectedFiles.map(async (data) => {
  //             jsonBase64.push(data);
  //         });

  //         for (var xml in fileArray) {
  //             try {
  //                 let base64 = await convertFileToBase64(fileArray[xml]);
  //                 let filebase64: FileBase64 = {
  //                     name: fileArray[xml].name,
  //                     base64: base64,
  //                 };
  //                 jsonBase64.push(filebase64);
  //             } catch (error) {
  //                 console.log("error", error);
  //             }
  //         }

  //         setSelectedFiles(jsonBase64);
  //         // Convert files to base64
  //         // const base64Files = await Promise.all(fileArray.map(getBase64File));
  //         // console.log("Uploaded PDFs:", base64Files);
  //     } catch (error) {
  //         console.error("File upload error:", error);
  //     } finally {
  //         e.target.value = ""; // Reset input field
  //     }
  // };

  const convertFileToBase64 = (file: any) => {
    return new Promise((resolve) => {
      let baseURL: any;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const triggerFileInput = () => {
    if (hiddenFileInputCreatePDF.current) {
      hiddenFileInputCreatePDF.current.click();
    }
  };

  const handleDelete = (fileName: string, index: number) => {
    Swal.fire({
      title: "คุณต้องการลบเอกสารนี้ใช่หรือไม่?",
      // text: fileName, fileName
      text: "",
      icon: "warning",
      showCancelButton: true,

      cancelButtonColor: "#d33",
      confirmButtonText: "ตกลง",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeDeleteFile(index);
      }
    });
  };

  const ChangeDeleteFile = (index: number) => {
    let arrDelete = selectedFiles;
    arrDelete.splice(index, 1);
    setSelectedFiles([...arrDelete]);
    Swal.fire({
      title: "ลบเอกสารสำเร็จ",
      text: "",
      icon: "success",

      confirmButtonText: "ตกลง",
    });
  };

  const handleSavePDF = async () => {
    // console.log("arrayBase64", datax)
    // setOpenAttachDoc(false)
    // setNameDoc("")
    if (fileslength < 5) {
      try {
        setLoading(true);
        var arrayBase64 = [];
        for (var xml of selectedFiles) {
          let base64result = xml.base64.split(",")[1];
          arrayBase64.push({ files_name: nameDoc, files_path: base64result });
        }
        var datax = {
          account_id_by_one_id: dataPageForm.dataform.one_id,
          hcode: dataPageForm.dataform.hcode,
          files: arrayBase64,
        };
        var { data } = await webapi.post(
          `${APIEndpointWeb.PostfilesPDF}`,
          datax,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );
        Swal.fire({
          title: "อัปโหลดไฟล์เอกสารสำเร็จ",
          text: "",
          icon: "success",

          confirmButtonText: "ตกลง",
        });
        getFilesPDF();
        setOpenAttachDoc(false);
        setNameDoc("");
        setSelectedFiles([]);
      } catch (error: any) {
        console.log(error);
        try {
          Swal.fire({
            title: error.response.data.status_result.status_message_th,
            text: "",
            confirmButtonText: "ตกลง",
            icon: "error",
          });
        } catch (error) {
          Swal.fire({
            title: "อัปโหลดไฟล์เอกสารไม่สำเร็จ",
            text: "",

            confirmButtonText: "ตกลง",
            icon: "error",
          });
        }
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "อัปโหลดเอกสารใบสมัครเพิ่มเติม สูงสุดได้ 5 ไฟล์",
        // text: "สามารถเลือกได้สูงสุด 1 ไฟล์เท่านั้น",
        icon: "warning",

        confirmButtonText: "ตกลง",
      });
    }
  };

  const handleCancel = () => {
    setOpenAttachDoc(false);
    setSelectedFiles([]);
    setNameDoc("");
  };

  return (
    <div>
      <Dialog
        sx={{ overflowY: "hidden" }}
        open={openAttachDoc}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseSuccessDialog();
          }
        }}
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "470px",
          },
        }}
      >
        <Grid container alignItems={"center"}>
          <Grid item>
            <img
              src={icon_attach_doc}
              alt="รูปภาพ"
              style={{
                width: "42px",
                height: "auto",
              }}
            />
          </Grid>
          <Grid item>
            <Typography fontWeight={700} fontSize={18}>
              แนบเอกสารใบสมัครเพิ่มเติม
            </Typography>
          </Grid>
          <IconButton
            onClick={handleCancel}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
        <DialogContent>
          <Grid gap={2}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: "#333333",
                  fontSize: "17px",
                  fontWeight: "500",
                  pb: 2,
                }}
              >
                ชื่อเอกสารแนบ <span style={{ color: "red" }}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="filled-multiline-static"
                value={nameDoc}
                onChange={handleNameDoc} // Keep this to update the form data
                // error={!!errors.diagnosis} // Show error if there's a validation error
                // helperText={errors.diagnosis} // Show the error message
                placeholder="ระบุชื่อเอกสารแนบ"
                variant="outlined"
                sx={{
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    borderRadius: "10px", // Ensure rounded corners
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: "#333333",
                  fontSize: "17px",
                  fontWeight: "500",
                  pb: 1,
                  pt: 3,
                }}
              >
                อัปโหลดเอกสารแนบ
              </Typography>
            </Grid>

            <Grid>
              <input
                // multiple
                type="file"
                accept="application/pdf"
                ref={hiddenFileInputCreatePDF}
                onChange={uploadPDF}
                style={{ display: "none" }}
              />
              <Grid
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                container
                direction="row"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={triggerFileInput}
                  sx={{
                    width: "100%",
                    border: "2px dashed #99b9f2",
                    color: "#1976d2",
                    padding: "23px",
                    backgroundColor: "#f4f9ff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",

                    "&:hover": {
                      border: "2px dashed #1976d2",
                      backgroundColor: "#f4f9ff",
                    },
                  }}
                >
                  <Grid item>
                    <div
                      style={{
                        backgroundColor: "#E4F2FC",
                        width: 82,
                        height: 80,
                        borderRadius: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={icon_import}
                        alt="icon_import"
                        style={{
                          width: "43px",
                          height: "auto",
                        }}
                      />
                    </div>
                  </Grid>
                  <Typography sx={{ pt: 1 }}>
                    วางเอกสาร หรือ{" "}
                    <span style={{ color: "#003466" }}>เลือกเอกสาร</span>
                  </Typography>
                  {/* <Typography sx={{ color: "#7B7B7B" }}>
                                        สามารถอัปโหลดเอกสารได้สูงสุด 5 ไฟล์
                                    </Typography> */}
                </Button>
              </Grid>

              <Box sx={{ paddingTop: 1 }}>
                <List sx={{ pt: 2, pb: 3 }}>
                  {
                    selectedFiles.length > 0
                      ? selectedFiles.map((file, index) => (
                          <ListItem
                            sx={{ backgroundColor: "#f4f9ff", borderRadius: 3 }}
                            key={index}
                            secondaryAction={
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => handleDelete(file.name, index)}
                              >
                                <img
                                  src={logo_del}
                                  alt="logo_del"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                  }}
                                />
                              </IconButton>
                            }
                          >
                            <ListItemIcon>
                              <img
                                src={icon_pdf}
                                alt="icon_pdf"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={file.name}
                              sx={{
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word",
                              }}
                            />
                          </ListItem>
                        ))
                      : ""
                    // <Box
                    //     sx={{
                    //         width: "100%",
                    //         height: 300,
                    //         backgroundColor: "#F5F7FA",
                    //         borderRadius: 3,
                    //         display: "flex",
                    //         flexDirection: "column",
                    //         alignItems: "center",
                    //         justifyContent: "center",
                    //         textAlign: "center",
                    //         padding: 2,
                    //     }}
                    // >
                    //     <img
                    //         src={no_documents}
                    //         alt="No Documents"
                    //         style={{
                    //             width: 60,
                    //             height: 60,
                    //             marginBottom: 8,
                    //         }}
                    //     />
                    //     <Typography
                    //         sx={{ fontWeight: 600, color: "#1F3B63" }}
                    //     >
                    //         ไม่มีเอกสาร
                    //     </Typography>
                    // </Box>
                  }
                </List>
              </Box>
              <Grid container justifyContent={"center"} spacing={2}>
                <Grid item>
                  <Button
                    onClick={handleCancel}
                    variant="outlined"
                    sx={{
                      borderRadius: 10,
                      pl: 4,
                      pr: 4,
                    }}
                  >
                    ยกเลิก
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleSavePDF}
                    variant="contained"
                    disabled={selectedFiles.length === 0 || nameDoc === ""}
                    sx={{
                      backgroundColor: "#0288D1",
                      borderRadius: 10,
                      pl: 4,
                      pr: 4,
                    }}
                  >
                    บันทึก
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DialogAttachDocPDF;
